export const MAX_PROFESSIONS = 3;

export const JOINER = ', ';
